import React from 'react';
import { Link } from "react-router-dom";
import {getExperimentDetail, updateExperiment} from '../services/ExperimentService';
import PartForm from './components/PartForm';

class EditExperiment extends React.Component {
    constructor(props) {
        super(props);
        var baseUrl = window.location.href;
        this.state = {
           id: baseUrl.substring(baseUrl.lastIndexOf('/') + 1),
           jwtToken: props.jwtToken,
           shared: false,
           name:  "",
           timeoutPeriod: "",
           description: "",
           parts: [],
           partKeyCount: 0
        };

        this.handleAddPart = this.handleAddPart.bind(this);
        this.handleExperimentInputChange = this.handleExperimentInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updatePartValues = this.updatePartValues.bind(this);
        this.removePart = this.removePart.bind(this);
    }

    componentDidMount() {
        getExperimentDetail(this.state.jwtToken, this.state.id)
        .then(response =>
            {
                var editParts = response.parts;
                editParts.forEach((part, index) => {
                    part.partNum = index;
                    part.varKeyCount = part.variables.length;

                    var vars = part.variables;
                    vars.forEach((variable, index) => {
                        variable.varNum = index;
                    });
                    part.variables = vars;
                });

                this.setState({
                    shared: response.shared,
                    name: response.name,
                    timeoutPeriod: response.timeoutPeriod,
                    description: response.description,
                    parts: editParts,
                    partKeyCount: editParts.length
                });
            }
        );
    }

    removePart = (id) => {
        this.setState({parts: this.state.parts.filter(function(part) {
            return part.partNum !== id
        })});
    }

    updatePartValues = (partData) => {
        var existingParts = this.state.parts;
        var index = existingParts.findIndex( (part) => part.partNum === partData.partNum);
        existingParts[index] = partData;
        this.setState({ parts: existingParts});
    }

    handleAddPart() {
        var existingParts = this.state.parts;
        existingParts.push({   partNum: this.state.partKeyCount,
                               name: "",
                               description: "",
                               designType: "BETWEEN_SUBJECT",
                               repetitionCount: 0,
                               variables: []});
        this.setState({ parts: existingParts, partKeyCount: (this.state.partKeyCount +1)});
    };

    handleExperimentInputChange = (e) => {
        if (e.target.name === "name") {
            this.setState({ name: e.target.value});
        }
        else if (e.target.name === "timeoutPeriod") {
            this.setState({ timeoutPeriod: e.target.value});
        }
        else if (e.target.name === "description") {
            this.setState({ description: e.target.value});
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.name === "") {
            this.setState({errorMessage: "Name field must not be empty."});
        } else {
            updateExperiment(this.state.jwtToken, this.state.id, this.state.name, this.state.timeoutPeriod, this.state.description, this.state.parts)
            .then(response => {
                    if (response.ok){
                        if (this.state.shared) {
                            window.location.pathname = "/shared";
                        } else {
                            window.location.pathname = "/";
                        }
                    } else {
                        response.json().then(body => {
                            const msg = body?.message || "";
                            if (msg.toLowerCase().includes("duplicate part") || msg.toLowerCase().includes("duplicate names")) {
                                alert("A part with this name already exists in this experiment. Please use a unique name for each part.");
                            } else if (msg.toLowerCase().includes("access token") || msg.toLowerCase().includes("experiment name")) {
                                alert("An experiment with this name already exists. Please choose a different name.");
                            } else {
                                alert("Changes could not be saved.");
                            }
                        }).catch(() => alert("Changes could not be saved."));
                    }
                }
            );
        }
    };

    render() {
    var renderedParts = [];
    if (typeof this.state.parts !==  "undefined"){
        for (var i = 0; i < this.state.parts.length; i++) {
            renderedParts.push( <PartForm key={this.state.parts[i].partNum} handleRemove={this.removePart}
                                    handleUpdate={this.updatePartValues} data={this.state.parts[i]}/> );
        }
    }
    return (
    <>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                <Link to="/">
                    <span title="Return to experiment listing">All experiments/</span>
                </Link>
                { (typeof this.state.shared !== "undefined" && this.state.shared) ?
                    <Link to="/shared">
                        <span title="Return to shared experiment listing">shared/</span>
                    </Link> : <></>
                }
                Edit experiment
            </h1>
            <form style={{paddingTop:"10px"}}>
                <div style={{display: "flex", flexWrap: "wrap"}}>
                    <div style={{width: "25%", marginRight: "50px"}}>
                        <div className="form-group">
                            <label>Name</label>
                            <input className="form-control" type="text" name="name" placeholder="Experiment name"
                            value={this.state.name}
                            onChange={(e) => this.handleExperimentInputChange(e)} />
                        </div>
                        <div style={{marginTop: "20px"}} className="form-group">
                            <label>Timeout [minutes]</label>
                            <input className="form-control" type="text" name="timeoutPeriod" placeholder="10"
                            value={this.state.timeoutPeriod}
                            onChange={(e) => this.handleExperimentInputChange(e)} />
                        </div>
                    </div>

                    <div style={{width: "30%"}} className="form-group">
                        <label>Description</label>
                        <textarea className="form-control" name="description" placeholder="Description"
                        value={this.state.description}
                        onChange={(e) => this.handleExperimentInputChange(e)} />
                    </div>
                </div>

                <h2>Parts</h2>
                <div id="partsArea">
                    <div className="alert alert-warning" style={{textAlign: "center" }} hidden={this.state.parts.length > 0}>
                      <strong>No part data</strong>
                    </div>
                </div>
                {renderedParts}



                <button style={{marginRight: "20px"}} type="button"
                    id="newPartButton" className="btn btn-default" onClick={this.handleAddPart} >
                    New part
                </button>

                <button type="submit" id="submitButton" className="btn btn-primary" onClick={this.handleSubmit} >
                    Submit
                </button>
            </form>
        </div>
    </>
    );
    }
}

export default EditExperiment;
